import { useIsMobile } from './use-mobile';
import { useCallback } from 'react';

export const useCTraderDeepLink = () => {
  const isMobile = useIsMobile();

  const openCTrader = useCallback(() => {
    if (isMobile) {
      try {
        // Try deep link first
        window.open('ctrader://open', '_self');
        
        // Fallback to app store after 500ms if app not installed
        setTimeout(() => {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          const storeUrl = isIOS 
            ? 'https://apps.apple.com/app/ctrader/id767428811'
            : 'https://play.google.com/store/apps/details?id=com.spotware.ct';
          window.open(storeUrl, '_blank');
        }, 500);
      } catch (error) {
        // If deep link fails, go directly to app store
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const storeUrl = isIOS 
          ? 'https://apps.apple.com/app/ctrader/id767428811'
          : 'https://play.google.com/store/apps/details?id=com.spotware.ct';
        window.open(storeUrl, '_blank');
      }
    } else {
      // Desktop: open web terminal
      window.open('https://ct.spotware.com', '_blank');
    }
  }, [isMobile]);

  return { openCTrader };
};
